module.exports = __webpack_public_path__ + "img/app_home5.19a154f6.png";